// These interfaces should match the API parameters, so we should use snake-case instead of camel-case
// BE CAREFUL when adding new interfaces or fields here. These should always accurately reflect the data that is being
// commonly passed around in our front-end e.g. if you add a field to 'AttributeType', you should be pretty sure that
// field makes sense/is necessary on 'AttributeType'

export type Datatype = 'STRING' | 'TIME' | 'PICTURE' | 'PHONE_NUM' | 'UID' | 'INT' | 'FILE';

export type Comparator = '=' | '<' | '<=' | '>' | '>=' | '!=';

export type Privilege = 'add_listable_attribute' | 'add_person' | 'view_advanced_documentation' |
  'export_csv_access' | 'deactivate_user_access' | 'view_audit_log' | 'modify_attribute_type' | 'modify_dead_attribute' | 'show_end_times';

export type Noop = () => void;

interface AccessRule {
  readonly conditions: string[];
}

export interface AccessRuleGroup {
  readonly id: number;
  readonly name: string;
  readonly access_rules: AccessRule[];
}

export const DefaultAdvancedOptions: AdvancedOptions = {
  derived: 'derived_and_non_derived',
  secondary: 'primary_and_secondary',
};

export interface AdvancedOptions {
  derived: 'derived_only' | 'derived_and_non_derived' | 'non_derived_only';
  secondary: 'secondary_only' | 'primary_and_secondary' | 'primary_only';
}

export interface Attribute {
  readonly id: number;
  value: string | number;
  readonly is_derived?: boolean;
  start_date: string;
  end_date?: string;
  is_secondary?:boolean
}

export interface AttributeType {
  // TOOD: this may be null
  attributes: Attribute[];
  readonly singleton: boolean;
  readonly name: string;
  readonly datatype: Datatype;
  readonly description: string;
  readonly listable: boolean;
  readonly is_editable: boolean;
  readonly sort_order: number;
  readonly can_modify_access_rule_group?: number;
  readonly can_view_access_rule_group?: number;
  readonly allow_passthrough_modify_access_rule_group?: boolean;
}

export interface Section {
  attribute_types: AttributeType[];
  readonly name: string;
  readonly description?: string;
}

export interface Genre {
  sections: Section[];
  readonly name: string;
  readonly description: string;
}

export interface UserData {
  genres: Genre[];
}

export interface PersonUserData extends UserData {
  person_id: number;
}

// TODO: the Filter definition includes is_editable & listable which aren't used and therefore should be cleaned up
export interface Filter {
  readonly singleton: boolean;
  readonly name: string;
  readonly datatype: Datatype;
  readonly description: string;
  readonly listable: boolean;
  readonly is_editable: boolean;

  readonly comparator: Comparator;
  readonly advancedOptions: AdvancedOptions;
  readonly attributes: Pick<Attribute, 'value'>[];
  // TODO: this should really be re-factored to be filterValue
  readonly filteredValues: string;
}
